import {gql} from "@irati/utils/gql"
import getQueryNames from "../../../services/apollo/helpers/getQueryNames"

const tokenQuery = gql`
  query GenerateIntercomToken($channel: ThirdPartyTokenChannel!) {
    generateIntercomToken(channel: $channel)
  }
`

export const tokenKey = getQueryNames(tokenQuery)[0]

export default tokenQuery
